import { useState, useEffect, useCallback } from "react";

const REMINDER_DELAY_HOURS = 24; // Show again after 24 hours
const LAST_DISMISSED_KEY = "healthReminderDismissedTimestamp";

const useHealthReminder = (isPopupRequired) => {
  // Read from localStorage initially to avoid unnecessary re-renders
  const lastDismissed = localStorage.getItem(LAST_DISMISSED_KEY);
  const shouldShow =
    !lastDismissed ||
    (new Date() - new Date(lastDismissed)) / (1000 * 60 * 60) >=
      REMINDER_DELAY_HOURS;

  const [showHealthInfoReminder, setShowHealthInfoReminder] = useState(
    shouldShow && isPopupRequired
  );

  useEffect(() => {
    if (!isPopupRequired) setShowHealthInfoReminder(false);
  }, [isPopupRequired]);

  const dismissHealthInfoReminder = useCallback(() => {
    localStorage.setItem(LAST_DISMISSED_KEY, new Date().toISOString());
    setShowHealthInfoReminder(false);
  }, []);

  return { showHealthInfoReminder, dismissHealthInfoReminder };
};

export default useHealthReminder;
